var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home_3_",
    "data-name": "home (3)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.987,
    height: 15,
    viewBox: "0 0 14.987 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1510",
    "data-name": "Group 1510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    "data-name": "Path 996",
    d: "M15.044,7.121,13.974,6.05,8.08.157a.536.536,0,0,0-.758,0L1.43,6.05.358,7.121a.536.536,0,0,0,.758.758l.156-.158v6.743A.536.536,0,0,0,1.808,15H13.594a.536.536,0,0,0,.536-.536V7.721l.157.157a.536.536,0,0,0,.758-.758ZM9.308,13.928H6.094V9.642H9.308Zm3.75,0H10.38V9.107a.536.536,0,0,0-.536-.536H5.558a.536.536,0,0,0-.536.536v4.822H2.344V6.65L7.7,1.292,13.058,6.65Z",
    transform: "translate(-0.208 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.fd86ac72.svg";
export { ForwardRef as ReactComponent };